import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import {
  Table,
  Row,
  Col,
  ConfigProvider,
  Button,
  InputNumber,
  Input,
  Divider,
  Radio,
} from "antd"
import { getListEngineer, getListQuarterTariff } from "store/actions"
import { serializeQuery } from "helpers/service_helper"
import { ListQuarterTariff } from "../common/ListQuarterTariff"
import { EngQuotaBurnColumnsAnt } from "./EngQuotaBurnColumnsAnt"
import { ListEngineer } from "../common/ListEngineer"
import "./engWork.scss"
import {
  engQuotaBurnApproved,
  engQuotaBurnUpdate,
  getEngQuotaBurnList,
  getEngQuotaBurnListSuccess,
  resetEngQuota,
} from "store/quotas/actions"
const ListEngQuotaBurn = props => {
  const {
    lstEngQuotaBurn,
    loading,
    onGetEngQuotaBurn,
    onGetEngQuotaBurnSuccess,
    onEngQuotaBurnUpdate,
  } = props

  const [quarterId, setQuarterId] = useState(null)
  const [engineerId, setEngineerId] = useState(null)
  const [des, setDes] = useState("")
  const [amountBurningValue, setAmountBurningValue] = useState(0)
  const [amountBurningSign, setAmountBurningSign] = useState(1)

  const onChange = (pagination, filters, sorter, extra) => {}

  const insert = () => {
    onEngQuotaBurnUpdate({
      id: null,
      qtId: quarterId,
      engId: engineerId,
      des: des,
      amountBurning: amountBurningValue * amountBurningSign,
    })
  }

  useEffect(async () => {
    if (quarterId) {
      handleSearchEngWork()
    } else {
      onGetEngQuotaBurnSuccess()
    }
  }, [quarterId, engineerId])
  // Fetch data or set initial values if needed
  const handleSearchEngWork = async val => {
    let searchQuery = {
      qtId: quarterId ? quarterId : "",
      engId: engineerId ? engineerId : "",
      burnTypeEnum:0

    }

    const params = serializeQuery(searchQuery)
    onGetEngQuotaBurn(params)
  }

  return (
    <>
      <Row gutter={[16, 6,16,6]}>
        <Col span={12}>
          <ListQuarterTariff selectQuarter={setQuarterId} props={props} />
        </Col>
        <Col span={12}>
          <ListEngineer selectEngineer={setEngineerId} props={props} />
        </Col>
        <Col span={12}>
          <div className="amount-burn-input">
            <Radio.Group
              className="amount-sign-toggle"
              value={amountBurningSign}
              onChange={e => setAmountBurningSign(e.target.value)}
            >
              <Radio.Button value={1} className="amount-sign-positive">
                +
              </Radio.Button>
              <Radio.Button value={-1} className="amount-sign-negative">
                -
              </Radio.Button>
            </Radio.Group>
            <InputNumber
              style={{ width: "100%" }}
              formatter={value =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              value={amountBurningValue}
              width={100}
              min={0}
              onChange={value => setAmountBurningValue(value ?? 0)}
            />
          </div>
        </Col>
        <Col span={12}>
          <Input.TextArea
            style={{ width: "100%" }}
            rows={2}
            width={100}
            onChange={e=>setDes(e.target.value)}

          />
        </Col>
        <Col span={24}>
          <Button
            disabled={loading || !quarterId || !quarterId}
            onClick={() => insert()}
            type="primary"
          >
            ذخیره
          </Button>
        </Col>
      </Row>
      <Divider />
      <div style={{ minHeight: "700px" }}>
        <Table
          loading={loading}
          size="small"
          pagination={{ pageSize: 20 }}
          sticky
          scroll={{ y: 450 }}
          columns={EngQuotaBurnColumnsAnt({
            props,
            period: props.lstQuarterTariff.find(x => x.id === quarterId)
              ?.period,
          })}
          rowClassName={(_r, i) => (i % 2 ? "odd" : "even")}
          rowKey={record => record.id}
          dataSource={lstEngQuotaBurn}
          onChange={onChange}
          style={{ zIndex: 99999 }}
        />
      </div>
    </>
  )
}

const mapStateToProps = ({ Quotas, QuarterTariffs, Engineers }) => ({
  lstEngQuotaBurn: Quotas.lstEngQuotaBurn,
  lstQuarterTariff: QuarterTariffs.lstQuarterTariff,
  lstEngineer: Engineers.lstEngineer,
  error: Quotas.error,
  success: Quotas.success,
  loading: Quotas.loading,
})

const mapDispatchToProps = dispatch => ({
  onGetEngQuotaBurn: query => dispatch(getEngQuotaBurnList(query)),
  onGetEngQuotaBurnSuccess: () => dispatch(getEngQuotaBurnListSuccess([])),
  onGetListQuarterTariff: () => dispatch(getListQuarterTariff()),
  onGetListEngineer: () => dispatch(getListEngineer()),
  onResetEngQuota: () => dispatch(resetEngQuota()),
  onEngQuotaBurnApproved: data => dispatch(engQuotaBurnApproved(data)),
  onEngQuotaBurnUpdate: data => dispatch(engQuotaBurnUpdate(data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ListEngQuotaBurn)
